<template>
  <div>
    <div v-if="!isMobile" class="tab-container">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-20"
        @click="changeTab('contracts')"
      >
        <investor-dashboard-card
          style="cursor: pointer; background-color: transparent"
        >
          <template slot="image">
            <i
              style="font-size: 55px; color: #8cc63f"
              class="fa fa-envelope-open-text"
            ></i>
          </template>
          <template slot="title">
            <p style="margin-top: 10px; font-size: 13px; font-weight: bold">
              My Contracts
            </p>
          </template>
        </investor-dashboard-card>
      </div>
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-20"
        @click="changeTab('performance')"
      >
        <investor-dashboard-card
          style="cursor: pointer; background-color: transparent"
        >
          <template slot="image">
            <i
              style="font-size: 55px; color: #8cc63f"
              class="fa fa-money-check"
            ></i>
          </template>
          <template slot="title">
            <p style="margin-top: 10px; font-size: 13px; font-weight: bold">
              Performance
            </p>
          </template>
        </investor-dashboard-card>
      </div>
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-20"
        @click="changeTab('account')"
      >
        <investor-dashboard-card
          style="cursor: pointer; background-color: transparent"
        >
          <template slot="image">
            <i
              style="font-size: 55px; color: #8cc63f"
              class="fa fa-comments-dollar"
            ></i>
          </template>
          <template slot="title">
            <p style="margin-top: 10px; font-size: 13px; font-weight: bold">
              My Account
            </p>
          </template>
        </investor-dashboard-card>
      </div>
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-20"
        @click="changeTab('plans')"
      >
        <investor-dashboard-card
          style="cursor: pointer; background-color: transparent"
        >
          <template slot="image">
            <i style="font-size: 55px; color: #8cc63f" class="fa fa-list"></i>
          </template>
          <template slot="title">
            <p style="margin-top: 10px; font-size: 13px; font-weight: bold">
              Plans
            </p>
          </template>
        </investor-dashboard-card>
      </div>
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-20"
        @click="changeTab('news')"
      >
        <investor-dashboard-card
          style="cursor: pointer; background-color: transparent"
        >
          <template slot="image">
            <i
              style="font-size: 55px; color: #8cc63f"
              class="fa fa-comment-dots"
            ></i>
          </template>
          <template slot="title">
            <p style="margin-top: 10px; font-size: 13px; font-weight: bold">
              News & Updates
            </p>
          </template>
        </investor-dashboard-card>
      </div>
    </div>
    <div
      v-else
      class="tab-container col-12"
      style="padding: 0; display: flex; justify-content: space-evenly"
    >
      <div @click="changeTab('contracts')">
        <investor-dashboard-mobile-card
          style="cursor: pointer; background-color: transparent"
        >
          <template slot="image">
            <i
              style="font-size: 25px; color: #8cc63f"
              class="fa fa-envelope-open-text"
            ></i>
          </template>
          <template slot="title">
            <p style="margin: 0; font-size: 8px; font-weight: bold">
              My Contracts
            </p>
          </template>
        </investor-dashboard-mobile-card>
      </div>
      <div @click="changeTab('performance')">
        <investor-dashboard-mobile-card
          style="cursor: pointer; background-color: transparent"
        >
          <template slot="image">
            <i
              style="font-size: 25px; color: #8cc63f"
              class="fa fa-money-check"
            ></i>
          </template>
          <template slot="title">
            <p style="margin: 0; font-size: 8px; font-weight: bold">
              Performance
            </p>
          </template>
        </investor-dashboard-mobile-card>
      </div>
      <div @click="changeTab('account')">
        <investor-dashboard-mobile-card
          style="cursor: pointer; background-color: transparent"
        >
          <template slot="image">
            <i
              style="font-size: 25px; color: #8cc63f"
              class="fa fa-comments-dollar"
            ></i>
          </template>
          <template slot="title">
            <p style="margin: 0; font-size: 8px; font-weight: bold">
              My Account
            </p>
          </template>
        </investor-dashboard-mobile-card>
      </div>
      <div @click="changeTab('plans')">
        <investor-dashboard-mobile-card
          style="cursor: pointer; background-color: transparent"
        >
          <template slot="image">
            <i style="font-size: 25px; color: #8cc63f" class="fa fa-list"></i>
          </template>
          <template slot="title">
            <p style="margin: 0px; font-size: 8px; font-weight: bold">Plans</p>
          </template>
        </investor-dashboard-mobile-card>
      </div>
      <div @click="changeTab('news')">
        <investor-dashboard-mobile-card
          style="cursor: pointer; background-color: transparent"
        >
          <template slot="image">
            <i
              style="font-size: 25px; color: #8cc63f"
              class="fa fa-comment-dots"
            ></i>
          </template>
          <template slot="title">
            <p style="margin: 0; font-size: 8px; font-weight: bold">News</p>
          </template>
        </investor-dashboard-mobile-card>
      </div>
    </div>
    <div v-if="viewTab == 'dashboard'" class="dashboard-container">
      <h3 class="portfolio-summary">PORTFOLIO SUMMARY</h3>
      <div style="margin-top: 45px">
        <div class="summary-details">
          <div class="portfolio-balance">
            <h5>Portfolio Balance</h5>
            <span style="margin-left: 10px" class="icon is-small is-right">
              <i
                @click="toggleShowPortfolio"
                class="fas"
                style="cursor: pointer"
                :class="{
                  'fa-eye-slash': !showPorfolioAccount,
                  'fa-eye': showPorfolioAccount,
                }"
              ></i>
            </span>
          </div>
          <div v-if="account && showPorfolioAccount" style="font-size: 32px">
            ${{
              Intl.NumberFormat("en-US", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 4,
              }).format(account.current_balance)
            }}
          </div>
          <div v-else-if="!showPorfolioAccount" style="font-size: 32px">
            *********
          </div>
        </div>
        <div style="display: flex; flex-wrap: wrap">
          <div
            style="text-align: left"
            class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
          >
            <div style="margin-top: 45px; display: flex">
              <label style="padding-left: 0" class="col-6">Net Deposits:</label>
              <label v-if="account && showPorfolioAccount" class="col-6"
                >${{ fixNumberView(calculateAccount("deposit")) }}</label
              >
              <label v-else-if="!showPorfolioAccount" class="col-6"
                >*******</label
              >
            </div>
            <div style="display: flex">
              <label style="padding-left: 0" class="col-6"
                >Net Withdrawals:</label
              >
              <label v-if="account && showPorfolioAccount" class="col-6"
                >${{ fixNumberView(calculateAccount("withdrawal")) }}</label
              >
              <label v-else-if="!showPorfolioAccount" class="col-6"
                >*******</label
              >
            </div>
            <div style="display: flex">
              <label style="padding-left: 0" class="col-6">Net Return:</label>
              <label v-if="account && showPorfolioAccount" class="col-6"
                >${{ fixNumberView(calculateNetReturn()) }}</label
              >
              <label v-else-if="!showPorfolioAccount" class="col-6"
                >*******</label
              >
            </div>
          </div>
          <div
            class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50 portfolio-bar"
          >
            <label
              style="
                font-weight: bold;
                font-size: 14px;
                color: #8cc63f;
                margin-bottom: 2px;
              "
              >INVESTMENT</label
            >
            <div
              style="
                border: 1px solid rgb(140, 198, 63);
                border-radius: 20px;
                background-color: rgb(140, 198, 63);
                height: 30px;
                margin-bottom: 30px;
              "
            >
              <div
                style="
                  height: 100%;
                  position: inherit;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  width: 100%;
                  font-weight: bold;
                  font-size: 12px;
                "
                v-if="account && showPorfolioAccount"
              >
                ${{ fixNumberView(calculateContractsPrincipals("active")) }}
              </div>
              <div
                style="
                  height: 100%;
                  position: inherit;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  width: 100%;
                  font-weight: bold;
                  font-size: 12px;
                "
                v-else-if="!showPorfolioAccount"
              >
                ********
              </div>
            </div>
            <label
              style="
                font-weight: bold;
                font-size: 14px;
                color: #8cc63f;
                margin-bottom: 2px;
              "
              >RETURN</label
            >
            <div
              style="
                border: 1px solid #8cc63f;
                border-radius: 20px;
                height: 30px;
                display: grid;
                grid-template-areas: 'inner-div';
              "
            >
              <div
                style="
                  height: 100%;
                  position: inherit;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  width: 100%;
                  font-weight: bold;
                  font-size: 12px;
                  grid-area: inner-div;
                  z-index: 2;
                "
                v-if="account && showPorfolioAccount"
              >
                ${{ fixNumberView(calculateNetReturn()) }}
              </div>
              <div
                style="
                  height: 100%;
                  position: inherit;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  width: 100%;
                  font-weight: bold;
                  font-size: 12px;
                  grid-area: inner-div;
                  z-index: 2;
                "
                v-if="!showPorfolioAccount"
              >
                ********
              </div>
              <div
                style="
                  height: 30px;
                  background-color: #8cc63f;
                  grid-area: inner-div;
                "
                v-if="account"
                :style="
                  calculateNetReturnROI() < 100
                    ? 'border-radius: 20px 0 0 20px; width:' +
                      calculateNetReturnROI() +
                      '%;'
                    : 'border-radius: 20px; width:100%;'
                "
              ></div>
            </div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="viewTab == 'plans'">
      <h3 class="titlesClass">Plans</h3>
      <div
        v-for="(plan, index) in plans"
        :key="index"
        style="justify-content: center; margin-top: 25px; display: flex"
      >
        <md-card
          class="md-card-stats"
          style="
            display: flex;
            justify-content: center;
            margin-bottom: 15px;
            border-radius: 30px;
            width: 85%;
            width: 85%;
          "
        >
          <div
            style="
              display: flex;
              align-items: center;
              flex-direction: row !important;
              min-height: 75px;
            "
          >
            <div
              style="
                padding: 0 50px;
                font-size: 18px;
                display: flex;
                align-items: center;
                cursor: pointer;
                justify-content: space-between;
              "
              @click="addOrRemovePlan(plan.id)"
              class="col-12"
            >
              {{ plan.code + " - " + plan.name }}
              <i
                style="font-size: 10px; padding-left: 20px"
                v-bind:class="
                  investorPlans.includes(plan.id)
                    ? 'fa fa-arrow-up'
                    : 'fa fa-arrow-down'
                "
              ></i>
            </div>
          </div>
          <div
            :style="
              investorPlans.includes(plan.id)
                ? 'display: flex'
                : 'display: none'
            "
            style="min-height: 100px"
          >
            <div class="col-12">
              <div
                class="col-12"
                style="
                  display: flex;
                  justify-content: space-evenly;
                  margin-top: 10px;
                "
              >
                <div
                  style="
                    border-radius: 20px;
                    padding: 32px;
                    border: solid rgb(140, 198, 63);
                    width: 100px;
                    text-align: center;
                    cursor: pointer;
                  "
                  :class="
                    selectedTabPlan == 'details'
                      ? 'selectedTabClass'
                      : 'unselectedTabClass'
                  "
                  @click="selectPlanTab('details')"
                >
                  <i
                    class="fa fa-receipt"
                    style="font-size: 26px"
                    :class="
                      selectedTabPlan == 'details'
                        ? 'selectedTabIconClass'
                        : 'unselectedTabIconClass'
                    "
                  ></i>
                </div>
                <div
                  style="
                    border-radius: 20px;
                    padding: 32px;
                    border: solid rgb(140, 198, 63);
                    width: 100px;
                    text-align: center;
                    cursor: pointer;
                  "
                  :class="
                    selectedTabPlan == 'allocation'
                      ? 'selectedTabClass'
                      : 'unselectedTabClass'
                  "
                  @click="selectPlanTab('allocation')"
                >
                  <i
                    class="fa fa-chart-pie"
                    style="font-size: 26px"
                    :class="
                      selectedTabPlan == 'allocation'
                        ? 'selectedTabIconClass'
                        : 'unselectedTabIconClass'
                    "
                  ></i>
                </div>
                <div
                  style="
                    border-radius: 20px;
                    padding: 32px;
                    border: solid rgb(140, 198, 63);
                    width: 100px;
                    text-align: center;
                    cursor: pointer;
                  "
                  :class="
                    selectedTabPlan == 'fees'
                      ? 'selectedTabClass'
                      : 'unselectedTabClass'
                  "
                  @click="selectPlanTab('fees')"
                >
                  <i
                    class="fa fa-list"
                    style="font-size: 26px"
                    :class="
                      selectedTabPlan == 'fees'
                        ? 'selectedTabIconClass'
                        : 'unselectedTabIconClass'
                    "
                  ></i>
                </div>
              </div>
              <div
                v-if="selectedTabPlan == 'fees'"
                class="col-12"
                style="margin: 40px 0"
              >
                <div
                  class="col-12"
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                  "
                >
                  <div
                    style="display: flex"
                    :style="isMobile ? ' width: 100%' : ' width: 75%'"
                  >
                    <h3 class="feesNote">Service Fees:</h3>
                    <h4
                      :style="
                        isMobile ? 'font-size: 10px;' : 'font-size: 16px;'
                      "
                      style="padding: 2px; margin-left: 5px"
                    >
                      2% annually cover servers’ & bots’ operations costs
                    </h4>
                  </div>
                  <div
                    style="display: flex; margin-top: 10px"
                    :style="isMobile ? ' width: 100%' : ' width: 75%'"
                  >
                    <h3 class="feesNote">Management Fees:</h3>
                    <h4
                      :style="
                        isMobile ? 'font-size: 10px;' : 'font-size: 16px;'
                      "
                      style="padding: 2px; margin-left: 5px"
                    >
                      ( charged annually. ONLY applies if there’s profit)
                    </h4>
                  </div>
                  <table
                    class="performanceTables table-striped table table-bordered"
                    :style="
                      isMobile ? ' width: 100%; font-size:9px' : ' width: 75%'
                    "
                    style="text-align: center; margin-top: 10px"
                  >
                    <thead>
                      <tr>
                        <th>Net Profit (%)</th>
                        <th>Your Share</th>
                        <th>YurBe Share</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(fee, key) in feesList" :key="key">
                        <td>{{ fee.net_profit }}</td>
                        <td>{{ fee.investor_share }}</td>
                        <td>{{ fee.yurbe_share }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div v-if="selectedTabPlan == 'details'">
                <div style="margin: 40px 0; display: flex">
                  <div
                    v-if="!isMobile"
                    class="col-2"
                    style="min-height: 100px; padding: 0"
                  ></div>
                  <div
                    :class="isMobile ? 'col-12' : 'col-10'"
                    style="padding: 0"
                  >
                    <div class="planInfoClass">
                      <label class="planInfoLabelClass">Bundle ID</label>
                      <label style="line-height: normal">
                        {{ plan.code }}
                      </label>
                    </div>
                    <div class="planInfoClass">
                      <label class="planInfoLabelClass">Description</label>
                      <label
                        style="
                          line-height: normal;
                          padding: 0 10px;
                          font-size: 12px;
                        "
                      >
                        {{ plan.description }}
                      </label>
                    </div>
                    <div class="planInfoClass">
                      <label class="planInfoLabelClass">Min Principal</label>
                      <label style="line-height: normal">
                        {{ fixNumberView(plan.min_principal) }}
                      </label>
                    </div>
                    <div class="planInfoClass">
                      <label class="planInfoLabelClass">Max Principal</label>
                      <label style="line-height: normal">
                        {{ fixNumberView(plan.max_principal) }}
                      </label>
                    </div>
                    <div class="planInfoClass">
                      <label class="planInfoLabelClass">Min Period</label>
                      <label style="line-height: normal">
                        {{ plan.min_period }}
                        {{
                          periodList.find((period) => {
                            return period.id == plan.period;
                          }).name
                        }}
                      </label>
                    </div>
                    <div class="planInfoClass">
                      <label class="planInfoLabelClass"
                        >Withdrawal Notice</label
                      >
                      <label style="line-height: normal">
                        {{ plan.withdrawal_notice }}
                        {{
                          periodList.find((period) => {
                            return period.id == plan.withdrawal_notice_period;
                          }).name
                        }}
                      </label>
                    </div>
                    <div class="planInfoClass">
                      <label class="planInfoLabelClass">Estimated ROI</label>
                      <label style="line-height: normal">
                        {{ plan.est_roi }}%
                      </label>
                    </div>
                  </div>
                </div>
                <!-- <div style="text-align: center; padding-bottom: 35px">
                  <button
                    @click="redirectToCreateContract(plan.id)"
                    style="
                      background-color: #8cc63f;
                      color: white;
                      padding: 10px 20px;
                      border: none;
                      border-radius: 5px;
                      margin-right: 10px;
                      cursor: pointer;
                    "
                  >
                    Invest Now
                  </button>
                </div> -->
              </div>
              <div
                v-if="selectedTabPlan == 'allocation'"
                class="col-12"
                style="margin: 40px 0; display: flex"
              >
                <div
                  class="col-12"
                  style="display: flex; justify-content: center"
                >
                  <div v-if="!plan.pieChartData">No Data Found</div>
                  <div v-else :style="!isMobile ? 'width: 500px' : ''">
                    <pie-chart
                      style="height: 200px"
                      :chart-data="plan.pieChartData"
                      :options="chartOptions"
                    ></pie-chart>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </md-card>
      </div>
    </div>
    <div v-else-if="viewTab == 'contracts'">
      <h3 class="titlesClass">My Contracts</h3>

      <div
        style="margin-top: 25px; justify-content: center; display: flex"
        v-for="(contracts, key) in groupedContracts"
        :key="key"
      >
        <md-card
          class="md-card-stats"
          style="
            display: flex;
            justify-content: center;
            margin-bottom: 15px;
            border-radius: 30px;
            width: 85%;
          "
        >
          <div
            style="
              display: flex;
              align-items: center;
              flex-direction: row !important;
              min-height: 75px;
            "
          >
            <div
              style="
                padding: 0 50px;
                font-size: 18px;
                display: flex;
                align-items: center;
                cursor: pointer;
                justify-content: space-between;
              "
              @click="addOrRemoveContract(key)"
              class="col-12"
            >
              {{ key == "active" ? "Active" : "In-Active" }}
              <i
                style="font-size: 10px; padding-left: 20px"
                v-bind:class="
                  investorContracts.includes(key)
                    ? 'fa fa-arrow-up'
                    : 'fa fa-arrow-down'
                "
              ></i>
            </div>
          </div>
          <div
            :style="
              investorContracts.includes(key)
                ? 'display: block'
                : 'display: none'
            "
            style="min-height: 100px; padding: 0 50px"
          >
            <vue-good-table
              v-if="!isMobile"
              :columns="contractsColumns"
              :rows="contracts"
              max-height="450px"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.label == 'Contract ID'">
                  <router-link
                    style="color: black !important; font-weight: bold"
                    @click.native="redirectToContract(props.row)"
                    to=""
                  >
                    {{ props.row.code }}
                  </router-link>
                </span>
              </template>
            </vue-good-table>
            <div v-else>
              <div v-for="(contract, key) in contracts" :key="key">
                <div class="planInfoClass">
                  <label class="planInfoLabelClass">Contract ID</label>
                  <label style="line-height: normal">
                    {{ contract.code }}
                  </label>
                </div>
                <div class="planInfoClass">
                  <label class="planInfoLabelClass">Plan</label>
                  <label style="line-height: normal">
                    {{ contractPlanName(contract) }}
                  </label>
                </div>
                <div class="planInfoClass">
                  <label class="planInfoLabelClass">Status</label>
                  <label
                    :class="getContractStatusClass(contract)"
                    style="line-height: normal"
                  >
                    {{ contractStatus(contract) }}
                  </label>
                </div>
                <div class="planInfoClass">
                  <label class="planInfoLabelClass">Length</label>
                  <label style="line-height: normal">
                    {{
                      getContractDuration(
                        contract.start_date,
                        contract.maturity_date
                      )
                    }}
                  </label>
                </div>
                <div class="planInfoClass">
                  <label class="planInfoLabelClass">Start Date</label>
                  <label style="line-height: normal">
                    {{ contract.start_date }}
                  </label>
                </div>
                <div class="planInfoClass">
                  <label class="planInfoLabelClass">End Date</label>
                  <label style="line-height: normal">
                    {{ contract.maturity_date }}
                  </label>
                </div>
                <div class="planInfoClass">
                  <label class="planInfoLabelClass">Currency</label>
                  <label style="line-height: normal">
                    {{ contract.currency_code }}
                  </label>
                </div>
                <div class="planInfoClass">
                  <label class="planInfoLabelClass">Investment</label>
                  <label style="line-height: normal">
                    {{ fixNumberView(contract.invested_principal) }}
                  </label>
                </div>
                <div class="planInfoClass">
                  <label class="planInfoLabelClass"
                    >Est. Earning Rate (p.a.)</label
                  >
                  <label style="line-height: normal">
                    {{ contractPlanEstROI(contract) }}%
                  </label>
                </div>
                <div
                  v-if="key != contracts.length - 1"
                  style="
                    height: 2px;
                    width: 60%;
                    background-color: lightgray;
                    margin-left: 20px;
                    margin-bottom: 10px;
                  "
                ></div>
              </div>
            </div>
            <!-- 
            <table style="width: 100%; text-align: center">
              <thead>
                <tr>
                  <th>Contract ID</th>
                  <th>Plan Type</th>
                  <th>Status</th>
                  <th>Length</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Currency</th>
                  <th>Investment</th>
                  <th>Estimated Earnings</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ contract.code }}</td>
                  <td>{{ contract.plan.name }}</td>
                  <td
                    v-if="contract.status == 'closed'"
                    style="font-weight: bold; color: red"
                  >
                    {{
                      statusList.find((status) => {
                        return status.id == contract.status;
                      }).name
                    }}
                  </td>
                  <td
                    v-else-if="contract.status == 'active'"
                    style="font-weight: bold; color: green"
                  >
                    {{
                      statusList.find((status) => {
                        return status.id == contract.status;
                      }).name
                    }}
                  </td>
                  <td v-else style="font-weight: bold; color: orange">
                    {{
                      statusList.find((status) => {
                        return status.id == contract.status;
                      }).name
                    }}
                  </td>
                  <td>
                    {{
                      getContractDuration(
                        contract.start_date,
                        contract.maturity_date
                      )
                    }}
                  </td>
                  <td>{{ contract.start_date }}</td>
                  <td>{{ contract.maturity_date }}</td>
                  <td>{{ contract.currency_code }}</td>
                  <td>{{ fixNumberView(contract.invested_principal) }}</td>
                  <td>{{ contract.plan.est_roi }}%</td>
                </tr>
              </tbody>
            </table> -->
          </div>
        </md-card>
      </div>
      <!-- <button
        v-if="!isMobile"
        class="btn btn-info btn-circle"
        type="button"
        @click="redirectToCreateContract()"
      >
        <i
          class="fa fa-plus"
          style="
            animation: none;
            top: 22px;
            left: 25px;
            color: #fff;
            font-size: 22px;
          "
        ></i>
      </button> -->
    </div>
    <div v-else-if="viewTab == 'account'">
      <h3 class="titlesClass">My Account</h3>
      <div
        style="
          margin-top: 25px;
          align-items: center;
          display: flex;
          flex-direction: column;
        "
      >
        <div v-if="!isMobile" style="width: 85%">
          <table style="width: 100%; text-align: center">
            <thead>
              <tr>
                <th>Date</th>
                <th>Transaction ID</th>
                <th>Type</th>
                <th>Description</th>
                <th>Amount</th>
                <!-- <th>Currency</th> -->
                <!-- <th>Exchange Rate</th> -->
                <th>Amount (USD)</th>
              </tr>
            </thead>
            <tbody>
              <tr
                style="line-height: 50px; text-align: center"
                v-for="(transaction, key) in transactions"
                :key="key"
              >
                <td>{{ moment(transaction.date).format("YYYY-MM-DD") }}</td>
                <td>{{ transaction.code }}</td>
                <!-- <td>
                  {{
                    transactionTypes.find((type) => {
                      return type.id == transaction.type;
                    }).name
                  }}
                </td> -->
                <td>
                  {{ transactionType(transaction) }}
                </td>
                <td>
                  {{ transaction.description }}
                </td>
                <td>
                  {{ fixNumberView(transaction.amount) }}
                  {{ transaction.currency.code }}
                </td>
                <!-- <td>
                  {{ transaction.exchange_rate }}
                </td> -->
                <td>
                  {{
                    fixNumberView(
                      transaction.amount * transaction.exchange_rate
                    )
                  }}
                </td>
              </tr>
            </tbody>
          </table>
          <div
            class="col-12"
            style="
              font-weight: bold;
              display: flex;
              margin-top: 30px;
              padding: 6px 65px 6px 45px;
              justify-content: space-between;
            "
          >
            <div>
              <label style="margin-right: 15px">Balance</label>
            </div>
            <div style="display: flex">
              <label style="padding-right: 5px">{{
                fixNumberView(account.current_balance)
              }}</label>
              <label>
                {{ account.currency.code }}
              </label>
            </div>
          </div>
        </div>
        <div v-else-if="isMobile" style="width: 85%">
          <vue-good-table
            id="transactionsTable"
            :columns="transactionsColumns"
            :rows="transactions"
            max-height="450px"
          >
          </vue-good-table>
          <div
            class="col-12"
            style="
              font-weight: bold;
              display: flex;
              margin-top: 30px;
              justify-content: space-between;
              padding: 0 10px;
              font-size: 12px;
            "
          >
            <div>
              <label style="margin-right: 15px">Balance</label>
            </div>
            <div style="display: flex">
              <label style="padding-right: 5px">{{
                fixNumberView(account.current_balance)
              }}</label>
              <label>
                {{ account.currency.code }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="viewTab == 'performance'">
      <h3 class="titlesClass">Performance</h3>
      <div
        style="margin-top: 25px; justify-content: center; display: flex"
        v-for="(contractReports, key) in sortedReports"
        :key="key"
      >
        <md-card
          class="md-card-stats"
          style="
            display: flex;
            justify-content: center;
            margin-bottom: 15px;
            border-radius: 30px;
            width: 85%;
          "
        >
          <div
            style="
              display: flex;
              align-items: center;
              flex-direction: row !important;
              min-height: 75px;
            "
          >
            <div
              style="
                padding: 0 50px;
                font-size: 18px;
                display: flex;
                align-items: center;
                cursor: pointer;
                justify-content: space-between;
              "
              @click="addOrRemoveReport(contractReports.contract_id)"
              class="col-12"
            >
              {{ contractReports.contract_id }}
              <i
                style="font-size: 10px; padding-left: 20px"
                v-bind:class="
                  investorReports.includes(contractReports.contract_id)
                    ? 'fa fa-arrow-up'
                    : 'fa fa-arrow-down'
                "
              ></i>
            </div>
          </div>
          <div
            :style="{
              display: investorReports.includes(contractReports.contract_id)
                ? 'block'
                : 'none',
              padding: isMobile ? '0 30px' : '0 50px',
            }"
            style="min-height: 100px"
          >
            <vue-good-table
              v-if="!isMobile"
              :columns="reportsColumns"
              :rows="contractReports.reports"
              max-height="450px"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'view'">
                  <i
                    @click="redirectToReport(props.row)"
                    class="fa fa-eye"
                    style="cursor: pointer"
                  ></i>
                </span>
              </template>
            </vue-good-table>
            <div v-else>
              <div
                style="display: flex; justify-content: space-between"
                v-for="(report, key) in contractReports.reports"
                :key="key"
              >
                <div class="reportInfoClass">
                  <label class="planInfoLabelClass">Plan</label>
                  <label style="line-height: normal">
                    {{ report.plan.name }}
                  </label>
                </div>
                <div class="reportInfoClass">
                  <label class="planInfoLabelClass">Year</label>
                  <label style="line-height: normal">
                    {{ report.plan_report.year }}
                  </label>
                </div>
                <div class="reportInfoClass">
                  <label class="planInfoLabelClass">ROI(%)</label>
                  <label style="line-height: normal">
                    {{ report.plan_report.roi }}%
                  </label>
                </div>
                <div class="reportInfoClass">
                  <label class="planInfoLabelClass">View</label>
                  <i
                    @click="redirectToReport(props.row)"
                    class="fa fa-eye"
                    style="cursor: pointer"
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </md-card>
      </div>
      <!-- <div
        v-for="(contract, index) in contracts"
        :key="index"
        style="margin-top: 25px; justify-content: center; display: flex"
        v-if="
          typeof contract.plan.performance === 'number' &&
          contract.plan.name != 'SEED' &&
          contract.plan.name != 'BALANCED'
        "
      >
        <md-card
          v-if="contract.status == 'active'"
          class="md-card-stats"
          style="
            display: flex;
            justify-content: center;
            margin-bottom: 15px;
            border-radius: 30px;
            width: 85%;
          "
        >
          <div
            style="
              display: flex;
              align-items: center;
              flex-direction: row !important;
              min-height: 75px;
            "
          >
            <div
              style="
                padding: 0 50px;
                font-size: 18px;
                display: flex;
                align-items: center;
                cursor: pointer;
                justify-content: space-between;
              "
              @click="addOrRemovePlan(contract.id)"
              class="col-12"
            >
              {{ contract.plan.code + " - " + contract.plan.name }}
              <i
                style="font-size: 10px; padding-left: 20px"
                v-bind:class="
                  investorPlans.includes(contract.id)
                    ? 'fa fa-arrow-up'
                    : 'fa fa-arrow-down'
                "
              ></i>
            </div>
          </div>
          <div
            :style="
              investorPlans.includes(contract.id)
                ? 'display: flex'
                : 'display: none'
            "
            style="min-height: 100px"
          >
            <div class="col-12">
              <div
                class="col-12"
                style="
                  display: flex;
                  justify-content: space-evenly;
                  margin-top: 10px;
                "
              >
                <div
                  style="
                    border-radius: 20px;
                    padding: 32px;
                    border: solid rgb(140, 198, 63);
                    width: 100px;
                    text-align: center;
                    cursor: pointer;
                  "
                  :class="
                    selectedTabPerformance == 'position'
                      ? 'selectedTabClass'
                      : 'unselectedTabClass'
                  "
                  @click="selectPerformanceTab('position')"
                >
                  <i
                    class="fa fa-chart-line"
                    style="font-size: 26px"
                    :class="
                      selectedTabPerformance == 'position'
                        ? 'selectedTabIconClass'
                        : 'unselectedTabIconClass'
                    "
                  ></i>
                </div>
                <div
                  v-if="
                    contract.plan.name.toLowerCase() == 'spark' ||
                    contract.plan.name.toLowerCase() == 'arkenstone'
                  "
                  style="
                    border-radius: 20px;
                    padding: 32px;
                    border: solid rgb(140, 198, 63);
                    width: 100px;
                    text-align: center;
                    cursor: pointer;
                  "
                  :class="
                    selectedTabPerformance == 'allocation'
                      ? 'selectedTabClass'
                      : 'unselectedTabClass'
                  "
                  @click="selectPerformanceTab('allocation')"
                >
                  <i
                    class="fa fa-chart-pie"
                    style="font-size: 26px"
                    :class="
                      selectedTabPerformance == 'allocation'
                        ? 'selectedTabIconClass'
                        : 'unselectedTabIconClass'
                    "
                  ></i>
                </div>
                <div
                  style="
                    border-radius: 20px;
                    padding: 32px;
                    border: solid rgb(140, 198, 63);
                    width: 100px;
                    text-align: center;
                    cursor: pointer;
                  "
                  :class="
                    selectedTabPerformance == 'fees'
                      ? 'selectedTabClass'
                      : 'unselectedTabClass'
                  "
                  @click="selectPerformanceTab('fees')"
                >
                  <i
                    class="fa fa-file-invoice"
                    style="font-size: 26px"
                    :class="
                      selectedTabPerformance == 'fees'
                        ? 'selectedTabIconClass'
                        : 'unselectedTabIconClass'
                    "
                  ></i>
                </div>
              </div>
              <div
                v-if="selectedTabPerformance == 'position'"
                class="col-12"
                style="margin: 40px 0; display: flex"
              >
                <div
                  v-if="!isMobile"
                  class="col-2"
                  style="min-height: 100px; padding: 0"
                ></div>
                <div :class="isMobile ? 'col-12' : 'col-10'" style="padding: 0">
                  <div class="planInfoClass">
                    <label class="planInfoLabelClass">Fund</label>
                    <label style="line-height: normal">
                      {{ fixNumberView(contract.invested_principal) }}
                    </label>
                  </div>
                  <div class="planInfoClass">
                    <label class="planInfoLabelClass"
                      >Current Est Balance *</label
                    >
                    <label style="line-height: normal">
                      {{
                        typeof contract.plan.performance === "number"
                          ? fixNumberView(
                              (contract.invested_principal *
                                contract.plan.performance) /
                                100 +
                                contract.invested_principal
                            ) + "$"
                          : "-"
                      }}
                    </label>
                  </div>
                  <div class="planInfoClass">
                    <label class="planInfoLabelClass">PNL *</label>
                    <label
                      :class="getPerformanceClass(contract.plan.performance)"
                      style="line-height: normal"
                    >
                      {{
                        typeof contract.plan.performance === "number"
                          ? fixNumberView(
                              (contract.invested_principal *
                                contract.plan.performance) /
                                100
                            ) + "$"
                          : "-"
                      }}
                    </label>
                  </div>
                  <div class="planInfoClass">
                    <label class="planInfoLabelClass">ROI *</label>
                    <label
                      :class="getPerformanceClass(contract.plan.performance)"
                      style="line-height: normal"
                    >
                      {{
                        typeof contract.plan.performance === "number"
                          ? fixNumberView(contract.plan.performance) + "%"
                          : "-"
                      }}
                    </label>
                  </div> -->
      <!-- <table
                    class="performanceTables table table-bordered"
                    style="width: 75%; text-align: center"
                  >
                    <thead>
                      <tr>
                        <th>Initial Investment</th>
                        <th>Current Est Balance *</th>
                        <th>PNL *</th>
                        <th>ROI *</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          {{ fixNumberView(contract.invested_principal) }}
                        </td>
                        <td>
                          {{
                            typeof contract.plan.performance === "number"
                              ? fixNumberView(
                                  (contract.invested_principal *
                                    contract.plan.performance) /
                                    100 +
                                    contract.invested_principal
                                ) + "$"
                              : "-"
                          }}
                        </td>
                        <td
                          :class="
                            getPerformanceClass(contract.plan.performance)
                          "
                        >
                          {{
                            typeof contract.plan.performance === "number"
                              ? fixNumberView(
                                  (contract.invested_principal *
                                    contract.plan.performance) /
                                    100
                                ) + "$"
                              : "-"
                          }}
                        </td>
                        <td
                          :class="
                            getPerformanceClass(contract.plan.performance)
                          "
                        >
                          {{
                            typeof contract.plan.performance === "number"
                              ? fixNumberView(contract.plan.performance) + "%"
                              : "-"
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table> -->
      <!-- <div>
                    <p class="performanceNotes">
                      * These figures are excluding service and management fees.
                      For more information, refer to the service and management
                      fees
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-if="
                  selectedTabPerformance == 'allocation' &&
                  (contract.plan.name.toLowerCase() == 'spark' ||
                    contract.plan.name.toLowerCase() == 'arkenstone')
                "
                class="col-12"
                style="margin: 40px 0"
              >
                <div
                  class="col-12"
                  style="display: flex; justify-content: center"
                >
                  <div :style="!isMobile ? 'width: 500px' : ''">
                    <pie-chart
                      style="height: 200px"
                      :chart-data="
                        contract.plan.name.toLowerCase() == 'spark'
                          ? cryptoChartData
                          : commoditiesChartData
                      "
                      :options="chartOptions"
                    ></pie-chart>
                  </div>
                </div>
              </div>
              <div
                v-if="selectedTabPerformance == 'fees'"
                class="col-12"
                style="margin: 40px 0"
              >
                <div
                  class="col-12"
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                  "
                >
                  <div
                    style="display: flex"
                    :style="isMobile ? ' width: 100%' : ' width: 75%'"
                  >
                    <h3 class="feesNote">Service Fees:</h3>
                    <h4
                      :style="
                        isMobile ? 'font-size: 10px;' : 'font-size: 16px;'
                      "
                      style="padding: 2px; margin-left: 5px"
                    >
                      2% annually (~{{ contract.invested_principal * 0.02 }} $
                      per year) cover servers’ & bots’ operations costs
                    </h4>
                  </div>
                  <div
                    style="display: flex; margin-top: 10px"
                    :style="isMobile ? ' width: 100%' : ' width: 75%'"
                  >
                    <h3 class="feesNote">Management Fees:</h3>
                    <h4
                      :style="
                        isMobile ? 'font-size: 10px;' : 'font-size: 16px;'
                      "
                      style="padding: 2px; margin-left: 5px"
                    >
                      ( charged annually. ONLY applies if there’s profit)
                    </h4>
                  </div>
                  <table
                    class="performanceTables table-striped table table-bordered"
                    :style="
                      isMobile ? ' width: 100%; font-size:9px' : ' width: 75%'
                    "
                    style="text-align: center; margin-top: 10px"
                  >
                    <thead>
                      <tr>
                        <th>Net Profit (%)</th>
                        <th>Your Share</th>
                        <th>YurBe Share</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(fee, key) in feesList" :key="key">
                        <td>{{ fee.net_profit }}</td>
                        <td>{{ fee.investor_share }}</td>
                        <td>{{ fee.yurbe_share }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </md-card>
      </div> -->
    </div>
    <div v-else-if="viewTab == 'news'">
      <h3 class="titlesClass">News & Updates</h3>
      <div class="newsClass">
        <vue-good-table id="newsTable" :columns="newsColumns" :rows="newsList">
        </vue-good-table>
        <!-- <table style="width: 100%">
          <thead>
            <tr>
              <th>Update</th>
              <th>Date</th>
              <th>Category</th>
              <th>Tags</th>
            </tr>
          </thead>
          <tbody>
            <tr
              style="line-height: 50px"
              v-for="(news, key) in newsList"
              :key="key"
            >
              <td class="col-8" style="line-height: 30px; padding-left: 0">
                {{ news.content }}
              </td>
              <td class="col-2">
                {{ moment(news.date).format("YYYY-MM-DD") }}
              </td>
              <td class="col-1">
                {{
                  categories.find((category) => {
                    return category.id == news.category;
                  }).name
                }}
              </td>
              <td class="col-1" style="line-height: 20px">
                {{ news.tags }}
              </td>
            </tr>
          </tbody>
        </table> -->
      </div>
    </div>
  </div>
</template>

<script>
import InvestorDashboardCard from "../../components/Cards/InvestorDashboardCard.vue";
import InvestorDashboardMobileCard from "../../components/Cards/InvestorDashboardMobileCard.vue";
import { mapState } from "vuex";
import NewsFilter from "../../filters/NewsFilter";
import InvestorContractsFilter from "../../filters/InvestorContractsFilter";
import InvestorAccountsFilter from "../../filters/InvestorAccountsFilter";
import TransactionsFilter from "../../filters/TransactionsFilter";
import moment from "moment";
import { EventBus } from "../../event-bus";
import { PieChart, LineChart } from "../../components/ChartJS";
import Spinner from "vue-simple-spinner";
import PlansFilter from "../../filters/PlansFilter";
import InvestorReportsFilter from "../../filters/InvestorReportsFilter";

export default {
  components: {
    InvestorDashboardCard,
    InvestorDashboardMobileCard,
    PieChart,
    LineChart,
    Spinner,
  },

  data() {
    return {
      isMobile: false,
      selected: [],
      showPorfolioAccount: false,
      viewTab: "dashboard",
      showPlanIndex: null,
      selectedTabPlan: "details",
      selectedTabPerformance: "position",
      investorPlans: [],
      investorContracts: [],
      investorReports: [],
      statusList: [
        { id: "active", name: "Active" },
        { id: "inactive", name: "InActive" },
        { id: "notstarted", name: "Not Started" },
        { id: "closed", name: "Closed" },
      ],
      transactionTypes: [
        { id: "deposit", name: "Deposit" },
        { id: "withdrawal", name: "Withdrawal" },
      ],
      periodList: [
        { id: "day", name: "Day" },
        { id: "week", name: "Week" },
        { id: "month", name: "Month" },
        { id: "year", name: "Year" },
      ],
      categories: [
        { id: "agriculture", name: "Agriculture" },
        { id: "commodities", name: "Commodities" },
        { id: "crypto", name: "Crypto" },
        { id: "stocks_etfs", name: "Stocks & ETFs" },
      ],
      reportsColumns: [
        {
          label: "Contract ID",
          field: "contract.code",
          sortable: false,
        },
        {
          label: "Plan Type",
          field: "plan.name",
          sortable: false,
        },
        {
          label: "Year",
          field: "plan_report.year",
          sortable: false,
        },
        {
          label: "Investment",
          field: this.reportInvestment,
          sortable: false,
        },
        {
          label: "ROI(%)",
          field: "plan_report.roi",
          sortable: false,
        },
        {
          label: "Grade",
          field: "plan_report.grade",
          sortable: false,
        },
        {
          label: "",
          field: "view",
          sortable: false,
        },
      ],
      contractsColumns: [
        {
          label: "Contract ID",
          field: "code",
          sortable: false,
        },
        {
          label: "Plan Type",
          field: this.contractPlanName,
          sortable: false,
        },
        {
          label: "Status",
          field: this.contractStatus,
          tdClass: this.getContractStatusClass,
          sortable: false,
        },
        {
          label: "Length",
          field: this.contractDuration,
          sortable: false,
        },
        {
          label: "Start Date",
          field: "start_date",
          sortable: false,
        },
        {
          label: "End Date",
          field: "maturity_date",
          sortable: false,
        },
        {
          label: "Currency",
          field: "currency_code",
          sortable: false,
        },
        {
          label: "Investment",
          field: this.contractInvestment,
          sortable: false,
        },
        {
          label: "Estimated Earnings",
          field: this.contractPlanEstROI,
          sortable: false,
        },
      ],
      newsColumns: [
        { label: "Update", field: "content", sortable: false },
        { label: "Date", field: this.getDate, sortable: false },
        { label: "Category", field: this.newsCategory, sortable: false },
        { label: "Tags", field: "tags", sortable: false },
      ],
      transactionsColumns: [
        { label: "Date", field: this.getDate, sortable: false },
        {
          label: "Transaction ID",
          field: "code",
          sortable: false,
        },
        { label: "Type", field: this.transactionType, sortable: false },
        // { label: "Amount", field: "amount", sortable: false },
        // { label: "Currency", field: "currency.code", sortable: false },
        // {
        //   label: "Exchange Rate",
        //   field: "exchange_rate",
        //   sortable: false,
        // },
        {
          label: "Amount (USD)",
          field: this.transactionUSDValue,
          sortable: false,
        },
      ],
      feesList: [
        { net_profit: "Zero or Less", investor_share: "-", yurbe_share: "0%" },
        { net_profit: "1% - 9.9%", investor_share: "95%", yurbe_share: "5%" },
        {
          net_profit: "10% - 19.9%",
          investor_share: "90%",
          yurbe_share: "10%",
        },
        {
          net_profit: "20% - 29.9%",
          investor_share: "80%",
          yurbe_share: "20%",
        },
        { net_profit: ">30%", investor_share: "75%", yurbe_share: "25%" },
      ],
      lineChartData: {
        labels: [],
        datasets: [],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: this.checkIsMobile() ? false : true,
          position: "left",
        },
        tooltips: {
          displayColors: false,
          callbacks: {
            label: function (tooltipItem, data) {
              let dataset = data.datasets[tooltipItem.datasetIndex];
              let currentValue = dataset.data[tooltipItem.index];
              let currentLabel = data.labels[tooltipItem.index];
              return currentLabel + " " + currentValue + "%";
            },
          },
        },
        animation: {
          duration: 0,
        },
        hover: {
          animationDuration: 0,
        },
        responsiveAnimationDuration: 0,
      },
      cryptoChartData: {
        labels: [
          "BTC",
          "ETH",
          "XRP",
          "ADA",
          "AVAX",
          "DOT",
          "BNB",
          "IOTA",
          "LINK",
          "XLM",
          "IOTX",
          "SAND",
          "Other",
        ],
        datasets: [
          {
            label: "Allocations",
            data: [20, 15, 15, 10, 5, 5, 4, 3.8, 3.5, 3.2, 3, 2.5, 10],
            backgroundColor: [
              "#8cc63f",
              "rgb(255, 99, 132)",
              "rgb(54, 162, 235)",
              "rgb(255, 205, 86)",
              "rgb(32, 133, 236)",
              "rgb(114, 180, 235)",
              "rgb(10, 65, 122)",
              "rgb(132, 100, 160)",
              "rgb(206, 169, 188)",
              "rgb(50, 50, 50)",
            ],
            hoverOffset: 4,
          },
        ],
      },
      commoditiesChartData: {
        labels: ["Gold", "Silver"],
        datasets: [
          {
            label: "Allocations",
            data: [70, 30],
            backgroundColor: ["#8cc63f", "rgb(255, 99, 132)"],
            hoverOffset: 4,
          },
        ],
      },
    };
  },
  created: function () {
    var investorReportsFilter = new InvestorReportsFilter();
    investorReportsFilter.investor_ids = [this.authUser.userable.id];
    investorReportsFilter.with = ["contract", "planReport"];
    investorReportsFilter.appends = ["plan"];
    this.$store.dispatch("searchInvestorReports", {
      filter: investorReportsFilter,
      resultMode: "default",
    });

    var planFilter = new PlansFilter();
    planFilter.with = ["clusterWeights", "projectWeights"];
    this.$store
      .dispatch("searchPlans", { filter: planFilter, resultMode: "default" })
      .then(() => {
        this.plans.forEach((plan) => {
          plan.pieChartData = {
            labels: [],
            datasets: [],
          };
          var pieData = [];
          if (plan.allocation_type == "clusters") {
            plan.cluster_weights.forEach((cluster) => {
              plan.pieChartData.labels.push(cluster.clusterName);
              pieData.push(cluster.weight);
            });
          } else if (plan.allocation_type == "projects") {
            plan.project_weights.forEach((project) => {
              plan.pieChartData.labels.push(project.projectName);
              pieData.push(project.weight);
            });
          }

          plan.pieChartData.datasets = [
            {
              label: "Allocations",
              data: pieData,
              backgroundColor: [
                "#8cc63f",
                "rgb(255, 99, 132)",
                "rgb(54, 162, 235)",
                "rgb(255, 205, 86)",
                "rgb(32, 133, 236)",
                "rgb(114, 180, 235)",
                "rgb(10, 65, 122)",
                "rgb(132, 100, 160)",
                "rgb(206, 169, 188)",
                "rgb(50, 50, 50)",
                "rgb(223, 199, 49)",
                "rgb(234, 136, 216)",
                "rgb(17, 51, 103)",
                "rgb(151, 105, 142)",
                "rgb(186, 199, 193)",
                "rgb(60, 60, 60)",
              ],
              hoverOffset: 4,
            },
          ];
        });
      });

    var contractFilter = InvestorContractsFilter();
    contractFilter.investor_ids = [this.authUser.userable.id];
    // contractFilter.status = ["active"];
    // contractFilter.with = ["plan"];
    contractFilter.appends = [
      // "plan_clusters",
      "currency_code",
      // "plan_projects",
    ];
    this.$store.dispatch("searchInvestorContracts", {
      filter: contractFilter,
      resultMode: "default",
    });
    // .then(() => {
    //   var plan_ids = [];
    //   this.contracts.forEach((contract) => {
    //     if (!plan_ids.includes(contract.plan_id)) {
    //       plan_ids.push(contract.plan_id);
    //     }
    //     contract.pieChartData = {
    //       labels: [],
    //       datasets: [],
    //     };
    //     var pieData = [];
    //     if (contract.plan.allocation_type == "clusters") {
    //       contract.plan_clusters.forEach((cluster) => {
    //         contract.pieChartData.labels.push(cluster.clusterName);
    //         pieData.push(cluster.weight);
    //       });
    //     } else if (contract.plan.allocation_type == "projects") {
    //       contract.plan_projects.forEach((project) => {
    //         contract.pieChartData.labels.push(project.projectName);
    //         pieData.push(project.weight);
    //       });
    //     }

    //     contract.pieChartData.datasets = [
    //       {
    //         label: "Allocations",
    //         data: pieData,
    //         backgroundColor: [
    //           "#8cc63f",
    //           "rgb(255, 99, 132)",
    //           "rgb(54, 162, 235)",
    //           "rgb(255, 205, 86)",
    //           "rgb(32, 133, 236)",
    //           "rgb(114, 180, 235)",
    //           "rgb(10, 65, 122)",
    //           "rgb(132, 100, 160)",
    //           "rgb(206, 169, 188)",
    //           "rgb(50, 50, 50)",
    //           "rgb(223, 199, 49)",
    //           "rgb(234, 136, 216)",
    //           "rgb(17, 51, 103)",
    //           "rgb(151, 105, 142)",
    //           "rgb(186, 199, 193)",
    //           "rgb(60, 60, 60)",
    //         ],
    //         hoverOffset: 4,
    //       },
    //     ];
    //   });
    //   this.$store
    //     .dispatch("searchPlansPerformance", { plan_ids: plan_ids })
    //     .then(() => {
    //       this.contracts.forEach((contract) => {
    //         this.plansPerformance.forEach((performance) => {
    //           if (contract.plan_id == performance.plan_id) {
    //             contract.plan.performance = performance.performance;
    //             return;
    //           }
    //         });
    //       });
    //     });
    // });
    this.$store.dispatch("searchTransactionCategories");
    let self = this;
    var accountsFilter = InvestorAccountsFilter();
    accountsFilter.investor_ids = [this.authUser.userable.id];
    this.$store
      .dispatch("searchInvestorAccounts", {
        filter: accountsFilter,
        resultMode: "default",
      })
      .then(() => {
        var transactionsFilter = TransactionsFilter();
        transactionsFilter.orderBy = ["date", "asc"];
        transactionsFilter.account_ids = [this.account.id];
        transactionsFilter.account_types = ["investor_account"];
        self.$store.dispatch("searchTransactions", {
          filter: transactionsFilter,
          resultMode: "default",
        });
      });

    EventBus.$on("changeTab", function (tab) {
      self.viewTab = tab;
    });
    var newsFilter = NewsFilter();
    newsFilter.status = ["published"];
    newsFilter.orderBy = ["date", "asc"];
    this.$store.dispatch("searchNews", {
      filter: newsFilter,
      resultMode: "default",
    });
  },
  mounted() {
    window.addEventListener("resize", this.onResize);
    this.onResize();
  },
  methods: {
    checkIsMobile() {
      return window.innerWidth < 768;
    },
    // redirectToCreateContract(id = null) {
    //   if (id) {
    //     this.$router.push({
    //       path: "/" + this.authUser.userable_type + "/contracts/create",
    //       query: { plan_id: id },
    //     });
    //   } else {
    //     this.$router.push(
    //       "/" + this.authUser.userable_type + "/contracts/create"
    //     );
    //   }
    // },
    redirectToReport(report) {
      this.$router.push(
        "/" +
          this.authUser.userable_type +
          "/contract/" +
          report.contract.code +
          "/" +
          report.contract.id +
          "/report/" +
          report.plan_report.year
      );
    },
    redirectToContract(contract) {
      this.$router.push(
        "/" + this.authUser.userable_type + "/contract/" + contract.code
      );
    },
    onResize() {
      this.isMobile = this.checkIsMobile();
    },
    toggleShowPortfolio() {
      this.showPorfolioAccount = !this.showPorfolioAccount;
    },
    getPerformanceClass(performance) {
      if (!performance) {
        return;
      } else if (performance > 0) {
        return "winning";
      } else if (performance < 0) {
        return "losing";
      }
    },
    contractInvestment(contract) {
      return this.fixNumberView(contract.invested_principal);
    },
    contractDuration(contract) {
      return this.getContractDuration(
        contract.start_date,
        contract.maturity_date
      );
    },
    contractStatus(contract) {
      return this.statusList.find((status) => {
        return status.id == contract.status;
      }).name;
    },
    contractPlanName(contract) {
      console.log(contract);
      return this.plans.find((plan) => {
        return plan.id == contract.plan_id;
      }).name;
    },
    contractPlanEstROI(contract) {
      return this.plans.find((plan) => {
        return plan.id == contract.plan_id;
      }).est_roi;
    },
    getContractStatusClass(contract) {
      if (contract.status == "active") {
        return "winning";
      } else return "losing";
    },
    getContract(contract) {
      return [contract];
    },
    newsCategory(news) {
      return this.categories.find((category) => {
        return category.id == news.category;
      }).name;
    },
    getDate(row) {
      return moment(row.date).format("YY-MM-DD");
    },
    transactionType(transaction) {
      var transactionCategory = this.transactionCategories.find((category) => {
        return category.id == transaction.category_id;
      }).name;
      if (
        (transactionCategory == "External") &
        (transaction.type == "deposit")
      ) {
        return "Fund";
      } else if (
        (transactionCategory == "Account") &
        (transaction.type == "deposit" || transaction.type == "withdrawal")
      ) {
        return "YurBe";
      } else if (
        (transactionCategory == "External") &
        (transaction.type == "withdrawal")
      ) {
        return "Cash Out";
      } else {
        return transactionCategory;
      }
    },
    transactionAmount(transaction) {
      return this.fixNumberView(transaction.amount);
    },
    transactionUSDValue(transaction) {
      return this.fixNumberView(transaction.amount * transaction.exchange_rate);
    },
    changeTab(viewTab) {
      this.viewTab = viewTab;
    },
    calculateAccount(type) {
      var totalDeposit = 0;
      if (type == "deposit") {
        this.transactions.forEach((transaction) => {
          if (
            transaction.type == "deposit" &&
            transaction.category.name == "External"
          ) {
            totalDeposit +=
              transaction.amount * transaction.exchange_rate -
              transaction.fees * transaction.exchange_rate;
          }
        });
        return totalDeposit;
      }
      var totalWithdrawal = 0;
      if (type == "withdrawal") {
        this.transactions.forEach((transaction) => {
          if (
            transaction.type == "withdrawal" &&
            transaction.category.name == "External"
          ) {
            totalWithdrawal +=
              transaction.amount * transaction.exchange_rate -
              transaction.fees * transaction.exchange_rate;
          }
        });
        return totalWithdrawal;
      }
    },
    fixNumberView(value) {
      const numFor = Intl.NumberFormat("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
      return value < 0
        ? "(" + Math.abs(value).toLocaleString() + ")"
        : numFor.format(value);
    },
    calculateContractsPrincipals(status = null) {
      var principal = 0;
      var current_date = moment().format("YYYY-MM-DD");
      if (status != null) {
        this.contracts.forEach((contract) => {
          if (
            contract.start_date <= current_date &&
            contract.maturity_date >= current_date &&
            contract.status == status
          ) {
            principal += contract.invested_principal;
          }
        });
      } else {
        this.contracts.forEach((contract) => {
          if (
            contract.start_date <= current_date &&
            contract.maturity_date >= current_date
          ) {
            principal += contract.invested_principal;
          }
        });
      }
      return principal;
    },
    calculateNetReturn() {
      // var principal = this.calculateContractsPrincipals();
      // var totalWithdrawals = this.calculateAccount("withdrawal");
      // var totalDeposits = this.calculateAccount("deposit");
      // return (
      //   ((this.account.current_balance + totalWithdrawal) * 100) / principal -
      //   100
      // );
      var netReturn = 0;
      this.transactions.forEach((transaction) => {
        if (
          transaction.type == "deposit" &&
          transaction.category.name == "Revenue"
        ) {
          netReturn +=
            transaction.amount * transaction.exchange_rate -
            transaction.fees * transaction.exchange_rate;
        } else if (
          transaction.type == "withdrawal" &&
          transaction.category.name == "Expenses"
        ) {
          netReturn -=
            transaction.amount * transaction.exchange_rate -
            transaction.fees * transaction.exchange_rate;
        } else if (
          transaction.type == "deposit" &&
          transaction.category.name == "Account"
        ) {
          netReturn +=
            transaction.amount * transaction.exchange_rate -
            transaction.fees * transaction.exchange_rate;
        } else if (
          transaction.type == "withdrawal" &&
          transaction.category.name == "Revenue"
        ) {
          netReturn -=
            transaction.amount * transaction.exchange_rate -
            transaction.fees * transaction.exchange_rate;
        }
      });
      return netReturn;
    },
    calculateNetReturnROI() {
      var netReturn = this.calculateNetReturn();
      var principal = this.calculateContractsPrincipals("active");
      return (netReturn * 100) / principal;
    },
    getContractDuration(start, end) {
      let duration = moment.duration(moment(start).diff(moment(end)));
      let durationString = "";
      if (duration.years() / -1) {
        durationString += duration.years() / -1 + " Years, ";
      }
      if (duration.months() / -1) {
        durationString += duration.months() / -1 + " Months, ";
      }
      if (duration.days() / -1) {
        durationString += duration.days() / -1 + " Days, ";
      }
      durationString = durationString.substring(0, durationString.length - 2);
      return durationString;
    },
    selectPlanTab(name) {
      this.selectedTabPlan = name;
    },
    selectPerformanceTab(name) {
      this.selectedTabPerformance = name;
    },
    addOrRemovePlan(id) {
      var flag = false;
      for (var i = this.investorPlans.length - 1; i >= 0; i--) {
        if (this.investorPlans[i] === id) {
          flag = true;
          this.investorPlans.splice(i, 1);
        }
      }
      if (!flag) {
        this.investorPlans.push(id);
      }
    },
    addOrRemoveReport(id) {
      var flag = false;
      for (var i = this.investorReports.length - 1; i >= 0; i--) {
        if (this.investorReports[i] === id) {
          flag = true;
          this.investorReports.splice(i, 1);
        }
      }
      if (!flag) {
        this.investorReports.push(id);
      }
    },
    addOrRemoveContract(id) {
      var flag = false;
      for (var i = this.investorContracts.length - 1; i >= 0; i--) {
        if (this.investorContracts[i] === id) {
          flag = true;
          this.investorContracts.splice(i, 1);
        }
      }
      if (!flag) {
        this.investorContracts.push(id);
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  computed: {
    sortedReports() {
      // return [...this.reports].sort(
      //   (a, b) => a.plan_report.year - b.plan_report.year
      // );

      // Create a map to group reports by contract_id
      const grouped = this.reports.reduce((acc, report) => {
        const contractId = report.contract.code; // Assuming contract_id is nested
        if (!acc[contractId]) {
          acc[contractId] = []; // Initialize array if not present
        }
        acc[contractId].push(report); // Add report to contract group
        return acc;
      }, {});

      // Sort reports within each contract by year
      for (const contractId in grouped) {
        grouped[contractId].sort(
          (a, b) => a.plan_report.year - b.plan_report.year
        );
      }
      // Convert the object back to an array if needed
      return Object.entries(grouped).map(([contract_id, reports]) => ({
        contract_id,
        reports,
      }));
    },
    groupedContracts() {
      return this.contracts.reduce(
        (grouped, contract) => {
          if (contract.status === "active") {
            grouped.active.push(contract);
          } else {
            grouped.closed.push(contract);
          }
          return grouped;
        },
        { active: [], closed: [] }
      );
    },

    moment() {
      return moment;
    },
    ...mapState({
      authUser: (state) => state.userStore.authUser,
      contracts: (state) =>
        state.contractStore.investorContractSearch.investorContracts,
      searchingContracts: (state) =>
        state.contractStore.investorContractSearch.searchingInvestorContracts,
      plansPerformance: (state) =>
        state.planStore.planPerformanceSearch.plansPerformance,
      plans: (state) => state.planStore.planSearch.plans,
      reports: (state) =>
        state.investorReportStore.investorReportSearch.investorReports,
      account: (state) =>
        state.accountsStore.investorAccountSearch.investorAccounts[0],
      transactions: (state) =>
        state.transactionStore.transactionSearch.transactions,
      transactionCategories: (state) =>
        state.transactionStore.transactionCategorySearch.transactionCategories,
      searchingTransactions: (state) =>
        state.transactionStore.transactionSearch.searchingTransactions,
      searchingAccount: (state) =>
        state.accountsStore.investorAccountSearch.searchingInvestorAccounts,
      newsList: (state) => state.newsStore.newsSearch.news,
    }),
  },
};
</script>
<style>
.infoClass {
  padding-left: 75px;
  display: flex;
  align-items: start;
}
.performanceNotes {
  margin-top: 20px;
  font-weight: bold;
  font-style: italic;
  width: 75%;
}
.feesNote {
  font-size: 18px;
  font-weight: bold;
  font-family: inherit;
  text-align: left !important;
  margin: 0;
}
.winning {
  color: green !important;
  font-weight: bold;
}

.vgt-table.bordered td,
.vgt-table.bordered th {
  border: hidden !important;
  background: none;
}

.vgt-inner-wrap {
  box-shadow: none !important;
}
.vgt-left-align {
  text-align: center;
}
.vgt-right-align {
  text-align: center;
}
table.vgt-table thead th {
  position: -webkit-sticky; /* for Safari */
  position: sticky;
  top: 0;
}
.vgt-table.bordered td,
.vgt-table.bordered th {
  background: #fff !important;
}

.losing {
  color: red !important;
  font-weight: bold;
}
.selectedTabIconClass {
  color: white !important;
}
.unselectedTabIconClass {
  color: rgb(140, 198, 63) !important;
}
.selectedTabClass {
  background-color: rgb(140, 198, 63) !important;
}
.unselectedTabClass {
  background-color: transparent !important;
}
.performanceTables th,
.performanceTables td {
  padding: 0.5rem;
  width: 25%;
}
.titlesClass {
  font-weight: bold;
  padding-left: 55px;
  text-align: left;
}
.newsClass {
  margin-top: 25px;
  justify-content: center;
  display: flex;
  padding: 60px;
}
#newsTable table.vgt-table {
  background-color: transparent !important;
}
#newsTable table.vgt-table td {
  font-size: 14px !important;
  padding: 0.75em 0.15em 0.75em 0.15em;
}
#newsTable .vgt-left-align {
  text-align: left;
  color: black;
}
#newsTable .vgt-table thead th {
  font-size: 16px !important;
  text-align: left !important;
  color: black;
}
#newsTable .vgt-responsive .vgt-table.bordered td,
.vgt-responsive .vgt-table.bordered th {
  background: none !important;
}
/* .table-striped > tbody > tr:nth-child(odd) > td,
.table-striped > tbody > tr:nth-child(odd) > th {
  background-color: #32cd32;
} */
@media screen and (max-width: 768px) {
  .titlesClass {
    padding-left: 25px;
  }
  .newsClass {
    padding: 25px;
  }
  #newsTable table.vgt-table td {
    font-size: 9px !important;
    padding: 0.75em 0.15em 0.75em 0.15em;
  }
  #newsTable .vgt-table thead th {
    font-size: 12px !important;
  }
  #transactionsTable .vgt-responsive .vgt-table.bordered td,
  .vgt-responsive .vgt-table.bordered th {
    background: none !important;
  }

  #transactionsTable table.vgt-table {
    background-color: transparent !important;
  }
  #transactionsTable .vgt-table thead th,
  table.vgt-table td {
    padding: 0;
    color: black;
  }
  .performanceNotes {
    font-size: 12px;
    width: 100%;
  }
  .feesNote {
    font-size: 12px;
  }
}
</style>

<style scoped>
.tab-container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.md-layout-item {
  box-sizing: border-box;
  flex: 0 0 20%; /* Initially, each tab occupies 20% of the container */
  padding: 10px;
  text-align: center;
}
.dashboard-container {
  padding: 0px 65px; /* Adjust padding for smaller screens */
}
/* Styles for portfolio summary and details */
.portfolio-summary {
  font-weight: bold;
}

.summary-details {
  margin-top: 20px; /* Add space between summary and details */
}

.portfolio-bar {
  padding: 0 50px;
}

.portfolio-balance {
  display: flex;
  margin-top: 20px; /* Add space between individual details */
  /* Other styles for portfolio balance */
}

.planInfoClass {
  display: flex;
  align-items: center;
  padding: 0;
  font-size: 13px;
}
.reportInfoClass {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  font-size: 13px;
  width: -webkit-fill-available;
}

.planInfoLabelClass {
  font-weight: bold;
  width: 25%;
}

.balance-amount {
  font-size: 24px;
  /* Other styles for balance amount */
}
.btn-circle {
  border-radius: 100%;
  width: 60px;
  height: 60px;
  position: fixed;
  bottom: 25px;
  right: 25px;
  background-color: #8cc63f;
  color: white;
  border: none;
  padding: 18px;
  cursor: pointer;
  -webkit-box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  -webkit-transition: background-color 0.3s;
  transition: background-color 0.3s;
}
.active {
  color: #8cc63f;
  font-weight: bold;
}

.closed {
  color: red !important;
  font-weight: bold;
}

/* Media query for smaller screens, like phones */
@media screen and (max-width: 768px) {
  .md-layout-item {
    flex: 0 0 50%; /* Each tab occupies 50% of the container on smaller screens */
  }
  .dashboard-container {
    padding: 0 30px; /* Adjust padding for smaller screens */
  }
  .selectedTabClass {
    width: 75px !important;
    height: 75px !important;
    padding: 24px !important;
  }
  .unselectedTabClass {
    width: 75px !important;
    height: 75px !important;
    padding: 24px !important;
  }
  .selectedTabIconClass {
    font-size: 20px !important;
  }
  .unselectedTabIconClass {
    font-size: 20px !important;
  }

  .planInfoClass {
    /* display: flex; */
    /* align-items: center; */
    padding-left: 20px;
  }
  .planInfoLabelClass {
    width: 50%;
  }

  /* .portfolio-summary {
  } */

  .summary-details {
    margin-top: 10px; /* Adjust margin for smaller screens */
  }

  .portfolio-balance {
    margin-top: 10px; /* Adjust margin for smaller screens */
  }

  .portfolio-bar {
    padding: 10px;
  }

  .balance-amount {
    font-size: 20px; /* Adjust font size for smaller screens */
  }
}
</style>



// WEBPACK FOOTER //
// resources/js/pages/investor/dashboard.vue